module.exports = __webpack_public_path__ + "static/media/StatementFeature2.5c71398f.avif";